export default {
    data() {
        return {
            msg: 'tempo',
        }
    },

    methods: {
    },

    created () {
        console.log('created')

        console.log('this.$route: ', this.$route)
    },

    mounted () {
        console.log('mounted::')
    },
}



// WEBPACK FOOTER //
// ./src/scripts/tempo.js